import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, finalize, map, switchMap, tap} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {ModalService} from '../../shared/services/modal.service';
import {UserService} from '../shared/user.service';
import {UserInfo} from '../shared/user-info.model';
import {LoaderService} from '../../shared/services/loader.service';
import {RolesLabelEnum} from '../shared/role.model';
import {TranslateService} from '@ngx-translate/core';
import {RolesLabelService} from '../shared/rolesLabel.service';
import {UserSearchCriteria} from '../../shared/user-search-criteria';

@Component({
  selector: 'app-sustainability-manager-list',
  templateUrl: './sustainability-manager-list.component.html',
  styleUrls: ['./sustainability-manager-list.component.scss']
})
export class SustainabilityManagerListComponent implements OnInit {

  public chepManagers: UserInfo[] = [];
  public selectedChepManagers: UserInfo[] = [];
  public filters = new UserSearchCriteria();

  @ViewChild('userTable') public userTable;

  loadSustainabilityManagers = (page: number, pageSize: number) => {
    return this.rolesLabelService.searchUsersByRole(RolesLabelEnum.SUSTAINABILITY_MANAGER, page, pageSize, this.filters)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error(error.error.message
            || this.translateService.instant('user-dashboard.users.sustainability-managers.list.error'));
          return [];
        }),
        finalize(() => this.loader.stopLoad())
      );
  }

  constructor(
    private rolesLabelService: RolesLabelService,
    private translateService: TranslateService,
    private userService: UserService,
    private modalService: ModalService,
    private loader: LoaderService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    /*this.loader.startLoad(false);

    this.rolesLabelService.getAllUsersByRole(RolesLabelEnum.SUSTAINABILITY_MANAGER)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error(error.error.message
            || this.translateService.instant('user-dashboard.users.sustainability-managers.list.error'));
          return [];
        }),
        tap(reviewers => this.sustainabilityManagers = reviewers),
        finalize(() => this.loader.stopLoad())
      ).subscribe();*/
  }

  public addRoleToExistingUser(content: TemplateRef<any>): void {

    const roleAddingModal = {
      title: this.translateService.instant('user-dashboard.users.sustainability-managers.add-role-modal.title'),
      content,
      closeButton: {
        text: this.translateService.instant('buttons.cancel'),
      },
      validateButton: {
        text: this.translateService.instant('buttons.validate'),
        disabled: () => this.selectedChepManagers.length === 0
      },
    }

    this.fetchEligibleChepManagers()
      .pipe(
        switchMap(() => this.modalService.open(roleAddingModal)),
        tap(() => this.loader.startLoad()),
        switchMap(() => this.rolesLabelService.addRoleToUsers(RolesLabelEnum.SUSTAINABILITY_MANAGER, this.selectedChepManagers)),
        finalize(() => {
          this.loader.stopLoad();
        })
    ).subscribe(
      () => {
        this.userTable.getPage(this.userTable.page, this.userTable.pageSize);
        this.selectedChepManagers = [];
        this.chepManagers = [];
        this.toastr.success(this.translateService.instant('user-dashboard.users.sustainability-managers.add-role-modal.success'))
      },
      (error: HttpErrorResponse) => {
        this.toastr.error(error.error.message
          || this.translateService.instant('user-dashboard.users.sustainability-managers.add-role-modal.error'));
      }
    );
  }

  public openRoleRemovalConfirmationPopup(content: TemplateRef<any>, userId: string) {
    const roleRemovalModal = {
      title: this.translateService.instant('user-dashboard.users.sustainability-managers.remove-role-modal.title'),
      content,
      closeButton: {
        text: this.translateService.instant('buttons.cancel'),
      },
      validateButton: {
        text: this.translateService.instant('buttons.validate'),
      },
    };

    this.modalService.open(roleRemovalModal)
      .pipe(
        switchMap(() => this.rolesLabelService.removeRoleOfUser(RolesLabelEnum.SUSTAINABILITY_MANAGER, userId)),
      ).subscribe(
        () => {
          this.userTable.getPage(this.userTable.page, this.userTable.pageSize);
          this.selectedChepManagers = [];
          this.chepManagers = [];
          this.toastr.success(this.translateService.instant('user-dashboard.users.sustainability-managers.remove-role-modal.success'))
        },
        (error) => this.toastr.error(error.error.message
          || this.translateService.instant('user-dashboard.users.sustainability-managers.remove-role-modal.error'))
      );
  }

  private filterEligibleChepManagers(sustainabilityManagers: UserInfo[], chepManagers: UserInfo[]) {
    const sustainabilityManagersIds = sustainabilityManagers.map(sustainabilityManager => sustainabilityManager.id);

    return chepManagers.filter(chepManager => !sustainabilityManagersIds.includes(chepManager.id));
  }

  private fetchEligibleChepManagers(): Observable<UserInfo[]> {
    if (this.chepManagers.length === 0) {
      this.loader.startLoad();
      return forkJoin({
        sustainabilityManagers: this.rolesLabelService.getAllUsersByRole(RolesLabelEnum.SUSTAINABILITY_MANAGER),
        chepManagers: this.userService.getChepManagers()
      }).pipe(
          map(({sustainabilityManagers, chepManagers}) => this.filterEligibleChepManagers(sustainabilityManagers, chepManagers)),
          tap((chepManagers: UserInfo[]) => this.chepManagers = chepManagers),
          finalize(() => this.loader.stopLoad()),
          catchError((error: HttpErrorResponse) => {
            console.error(error);
            const errorMessage = error.error.message
              || this.translateService.instant('user-dashboard.users.sustainability-managers.list.error-chep-managers');
            this.toastr.error(errorMessage);
            return [];
          })
        );
    } else {
      return of(this.chepManagers);
    }
  }
}
